import jaLocale from 'element-ui/lib/locale/lang/ja'
const ja_jp = {
    ...jaLocale
}

export default ja_jp
